import { UseMutateFunction } from "@tanstack/react-query";
import { api } from "data";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { IListingQuestions } from "../ListingQuestions.interfaces";

export const useReorderBookingQuestions = () => {
  return useCustomMutation({
    url: api.questions.rorder_questions,
    onMutate: () => null,
    onSettled: () => null,
    onSuccess: () => null,
  });
};
